ACC.checkout = {

    _autoload: [
        "bindCheckO",
        "bindForms",
        "bindSavedPayments",
        "validateCheckoutLastStep",
        "disabledDeliveryMethod",
        "initDelivryPointRelais",
        "events",
        "summaryScroll",
        "clickOrderConfirmationBanner",
        "viewOrderConfirmationBanner",
        "quoteTransformationAdaptation"
    ],

    checkoutQuestionOk: false,
    checkoutPaymentOk: false,
    orderSummaryTopPosition: 0,
    pointRelaisSelected: false,

    initDelivryPointRelais: function () {

        $(document).on("click", "input[name=delivery_method]", function (e) {
            if ($(this).val() == 'Point_relais') {
                var title = $('.relayPoints-title').html();

                if ($(window).width() > 639) {
                    ACC.colorbox.open(title, {
                        href: "#pointRelaisBlock",
                        inline: true,
                        maxWidth: "580",
                        height: "600px",
                        //fixed: true,

                        onOpen: function () {
                            //$('html,body').css('overflow', 'hidden');
                            $("#colorbox").addClass("box2");
                        },

                        onComplete: function () {

                            $('.page-multiStepCheckoutSummaryPage #summaryCheckoutForm').on('click', function () {
                                if (!$(document).find('.addressEntry.selected').length) {
                                    $('.delivery-radio-btn input').prop('checked', false);
                                    $('.delivery-radio-btn.Enlevement input').prop('checked', true);
                                }
                            });
                        },

                        onClosed: function () {
                            //$('html,body').removeAttr('style');

                            if (!$(document).find('.addressEntry.selected').length || ACC.checkout.pointRelaisSelected) {
                                $('.delivery-radio-btn input').prop('checked', false);
                                var perviousDM = $('.previousDM').val();
                                $('.delivery-radio-btn.' + perviousDM + ' input').prop('checked', true);
                            }
                        }
                    });
                } else {
                    $('#pointRelaisBlock').slideDown();
                    $("html, body").animate({
                        scrollTop: $('#pointRelaisBlock').offset().top - 59
                    });

                    setTimeout(function () {
                        if ($('#Point_relais').prop('checked') && $(document).find('.selected.addressEntry').length == 0) {
                            $('#deliveryMethodSubmit').attr('disabled', 'true');
                        }
                    }, 1000);
                }
            } else {
                if(!$("#deliveryMethodSubmit").attr("data")){
                    $('#deliveryMethodSubmit').removeAttr('disabled');
                }
                $('#pointRelaisBlock').slideUp();
                $('.delivery-radio-btn').removeClass('selectedStep');
            }

            $(window).on("resize", function (e) {
                if ($(window).width() > 639) {
                    $('#pointRelaisBlock').removeAttr('style');
                    if(!$("#deliveryMethodSubmit").attr("data")){
                        $('#deliveryMethodSubmit').removeAttr('disabled');
                    }
                } else if ($(window).width() <= 639 && $('#colorbox').length > 0) {
                    ACC.colorbox.close();
                }
            });
        });
    },
    bindForms: function () {
        $(document).on("click", "#choosePaymentType_continue_button", function (e) {
            e.preventDefault();
            $(this).prop('disabled', true).addClass('disabled');
            if ($('#PaymentTypeSelection_CARD').is(':checked')) {
                $('#PaymentTypeSelection_CARD').removeAttr("disabled")
                var payType = 'Carte bancaire'
            } else {
                $('#PaymentTypeSelection_ACCOUNT').removeAttr("disabled")
                var payType = 'Paiement sur compte'
            }

            /* Google Tag Manager */

/*               window.dataLayer = window.dataLayer || [];
                 window.dataLayer.push({
                'event': 'validation_transactionPaymentType',
                'transactionPaymentType': payType
            });*/
            /* Google Tag Manager */

            //$('#selectPaymentTypeForm').submit();
        });

        $(document).on("click", "#addressSubmit", function (e) {
            e.preventDefault();

            var adresseDel = $('#deleteAddressTrue');
            if (adresseDel == null || adresseDel.length == 0) {
                var myForm = $('#addressForm');
                var formToserialize = "shippingAddress";
                ACC.checkout.saveFormToCookie(myForm, formToserialize);
            }

            if ($("#saveAddressInMyAddressBook").is(':checked')) {
                var myForm = $('#addressForm');
                ACC.checkout.deleteFormsCookie(myForm);
            }

            $('#addressForm').submit();
        })

        $(document).on("change", "#enterBillingAddress", function (e) {
            if (this.checked) {
                $('#billingAddressForm, #addressbookBilling').slideDown();
                $('#billingAddressForm .amds-form-field').removeClass('amds-form-field-disabled');
                $('#billingAddressForm .amds-form-field input, #billingAddressForm .amds-form-field select').removeAttr('disabled');
            } else {
                $('#billingAddressForm, #addressbookBilling').slideUp();
                $('#billingAddressForm .amds-form-field').addClass('amds-form-field-disabled');
                $('#billingAddressForm .amds-form-field input, #billingAddressForm .amds-form-field select').attr('disabled', 'true');
            }
        })

        $(document).on("change", "#saveAddressInMyAddressBook", function (e) {
            if (this.checked) {
                $(this).closest(".defaultAddressCheckbox").next(".amds-form-field").slideDown();
            } else {
                $(this).closest(".defaultAddressCheckbox").next(".amds-form-field").slideUp();
            }
        })

        // $(window).on('resize', function(){
        // 	ACC.checkout.initDelivryPointRelais();
        // });

        $(document).on("click", ".edit_point_relais", function (e) {
            $('#Point_relais').click();
        });

        $(document).on("click", "#deliveryMethodSubmit", function (e) {
            e.preventDefault();
            if ($('#Point_relais').is(':checked')) {
                var deliveryMeth = 'Point relais'
            } else if ($('#Enlevement').is(':checked')) {
                var deliveryMeth = 'Enlèvement'
            } else if ($('#Livraison').is(':checked')) {
                var deliveryMeth = 'Livraison standard'
            } else {
                var deliveryMeth = 'Tournée'
            }

            /* Google Tag Manager */
/*               window.dataLayer = window.dataLayer || [];
                 window.dataLayer.push({
                'event': 'validation_delivery',
                'productDelivery': deliveryMeth
            });*/
            /* Google Tag Manager */

            $('#selectDeliveryMethodForm').submit();
        });
    },

    bindSavedPayments: function () {
        $(document).on("click", ".js-saved-payments", function (e) {
            e.preventDefault();

            var title = $("#savedpaymentstitle").html();

            $.colorbox({
                href: "#savedpaymentsbody",
                inline: true,
                maxWidth: "100%",
                opacity: 0.7,
                //width:"320px",
                title: title,
                close: '<span class="glyphicon glyphicon-remove"></span>',
                onComplete: function () {
                }
            });
        })
    },

    bindCheckO: function () {
        var cartEntriesError = false;

        // Alternative checkout flows options
        $('.doFlowSelectedChange').change(function () {
            if ('multistep-pci' == $('#selectAltCheckoutFlow').val()) {
                $('#selectPciOption').show();
            } else {
                $('#selectPciOption').hide();

            }
        });

        $('.js-continue-shopping-button').click(function () {
            var checkoutUrl = $(this).data("continueShoppingUrl");
            window.location = checkoutUrl;
        });

        $('.expressCheckoutButton').click(function () {
            document.getElementById("expressCheckoutCheckbox").checked = true;
        });

        $(document).on("input", ".confirmGuestEmail,.guestEmail", function () {
            var orginalEmail = $(".guestEmail").val();
            var confirmationEmail = $(".confirmGuestEmail").val();

            if (orginalEmail === confirmationEmail) {
                $(".guestCheckoutBtn").removeAttr("disabled");
            } else {
                $(".guestCheckoutBtn").attr("disabled", "disabled");
            }
        });

        $('.js-continue-checkout-button').click(function (e) {
            $(this).prop('disabled', true).addClass('disabled');
            var checkoutUrl = $(this).data("checkoutUrl");
            var isAbandonedCart = $.cookie('isAbandonedCart');
            if (isAbandonedCart != null & isAbandonedCart == 'true') {
                ACC.track.validateAbandonnedCartEvent();
            }
            cartEntriesError = ACC.pickupinstore.validatePickupinStoreCartEntires();
            if (!cartEntriesError) {
                /* Google Tag Manager */
                // ACC.track.cartValidationEvent($('.express-checkout-checkbox').is(":checked"))
                /* Google Tag Manager */

                var expressCheckoutObject = $('.express-checkout-checkbox');
                if (expressCheckoutObject.is(":checked")) {
                    window.location = expressCheckoutObject.data("expressCheckoutUrl");
                } else {
                    var flow = $('#selectAltCheckoutFlow').val();
                    if (flow == undefined || flow == '' || flow == 'select-checkout') {
                        // No alternate flow specified, fallback to default behaviour
                        window.location = checkoutUrl;
                    } else {
                        // Fix multistep-pci flow
                        if ('multistep-pci' == flow) {
                            flow = 'multistep';
                        }
                        var pci = $('#selectPciOption').val();

                        // Build up the redirect URL
                        var redirectUrl = checkoutUrl + '/select-flow?flow=' + flow + '&pci=' + pci;
                        window.location = redirectUrl;
                    }
                }
            }
            return false;
        });
    },

    validateCheckoutLastStep: function () {
        ACC.checkout._paymentCheck();
    },

    _paymentCheck: function () {
        $(document).on('click', '.payment-check', function () {
            var isOk = true;

            $('.payment-check').each(function () {
                var that = $(this);

                if (!that.find('input[type=checkbox]').is(':checked')) {
                    isOk *= false;
                    that.addClass('error');
                } else if ($('.payment-check').data('isasmagent')) {
                    isOk *= false;
                    that.addClass('error');
                } else {
                    isOk *= true;
                    that.removeClass('error');
                }
            });

            ACC.checkout.checkoutPaymentOk = !!+isOk; // convert from int to boolean
            ACC.checkout._checkIsOk();
        });
    },

    _checkIsOk: function () {
        var btns = $('.btn-place-order, .scheduleReplenishmentButton');

        if (ACC.checkout.checkoutPaymentOk) {
            btns.removeAttr('disabled');
        } else {
            btns.attr('disabled', 'disabled');
        }
    },

    saveFormToCookie: function (form, formToserialize) {
        var name = $(form).attr('id');
        var data = ACC.address.serializeJSON(form, formToserialize);
        $.cookie(name, data, {expires: 365});

    },

    events: function () {
        if ($(window).width() > 639) {
            ACC.checkout.sendRequestDilvtyMethode('#pointRelaisMethodForm #summaryCheckoutForm');
        } else {
            ACC.checkout.sendRequestDilvtyMethode('#deliveryMethodSubmit');
        }
    },

    sendRequestDilvtyMethode: function (selector) {

        $(document).on('click', selector, function (e) {
            e.preventDefault();
            var url = '',
                selectedAddressEntry = $(document).find('.selected.addressEntry');

            if (selectedAddressEntry.length) {
                url = selectedAddressEntry.data('url-get');
            } else {
                url = $('#pointRelaisBlock').data('url');
            }

            $.ajax({
                url: url,
                type: 'GET',
                success: function (response) {
                    $('#selectedPR_lat').val(selectedAddressEntry.data('checkout-lat'));
                    $('#selectedPR_lng').val(selectedAddressEntry.data('checkout-lng'));

                    if ($(window).width() > 639) {
                        $('.closeColorBox').trigger('click');
                    }
                }
            });
            if ($(window).width() > 639) {
                location.reload();
            }

        });

    },

    initCheckoutMap: function () {


        var agencyLat = parseFloat($('#pointRelaisBlock').data('agency-lat')),
            agencyLng = parseFloat($('#pointRelaisBlock').data('agency-lng'));

        var centerPoint = new google.maps.LatLng(agencyLat, agencyLng);
        var mapOptions = {
            zoom: 13,
            zoomControl: true,
            panControl: true,
            streetViewControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            center: centerPoint
        }

        var map = new google.maps.Map(document.getElementById("checkoutMap"), mapOptions);

        var iconBase = '/_ui/responsive/theme-amds/images/';
        var icons = {
            store: {
                icon: iconBase + 'agence.png'
            },
            relaypoint: {
                icon: iconBase + 'point_relais.png',
                iconSelected: iconBase + 'point_relais_selected.png'
            }
        };
        var features = [
            {
                position: new google.maps.LatLng(agencyLat, agencyLng),
                type: 'store',
                lat: 0,
                lng: 0
            }
        ];

        $('#pointRelaisBlock .addressEntry').each(function (i, ele) {
            var latr = parseFloat($(ele).data('checkout-lat')),
                lngr = parseFloat($(ele).data('checkout-lng'));

            features.push({
                position: new google.maps.LatLng(latr, lngr),
                type: 'relaypoint',
                lat: $(ele).data('checkout-lat'),
                lng: $(ele).data('checkout-lng')
            });
        });

        $('#pointRelaisBlock .addressEntry').removeClass('selected').hide();

        var key = -1,
            markers = [];

        features.forEach(function (feature) {
            var marker = new google.maps.Marker({
                position: feature.position,
                icon: icons[feature.type].icon,
                map: map,
                id: 'block' + key
            });

            if (feature.lat == $('#selectedPR_lat').val() && feature.lng == $('#selectedPR_lng').val() && marker.id !== 'block-1') {
                marker.setIcon(icons.relaypoint.iconSelected);
                $(document).find('#pointRelaisBlock .' + marker.id).addClass('selected').show();
            }

            markers.push(marker);

            google.maps.event.addListener(marker, 'click', function () {
                $('#pointRelaisBlock .addressEntry').removeClass('selected').hide();


                if ($(window).width() < 639) {
                    $('#deliveryMethodSubmit').attr('disabled', 'true');
                    setTimeout(function () {
                        $('.Point_relais').addClass('selectedStep');
                    }, 300)
                }


                $.each(markers, function (i, m) {
                    if (m.id !== 'block-1') {
                        m.setIcon(icons.relaypoint.icon);
                    }
                });

                if (marker.id !== 'block-1') {
                    $(document).find('#pointRelaisBlock .' + marker.id).addClass('selected').show();
                    marker.setIcon(icons.relaypoint.iconSelected);

                    if ($(window).width() < 639) {
                        $('#deliveryMethodSubmit').removeAttr('disabled');
                        $('.Point_relais').removeClass('selectedStep');
                    }
                }

                $(window).trigger('resize');
            });

            key++;
        });

        $(window).trigger('resize');
    },

    disabledDeliveryMethod: function () {

        $(".delivery-radio-btn.disabled").each(function (i, el) {

            $(el).tooltip({
                content: function () {

                    return $("#selectDeliveryMethodForm .hidden:eq(" + i + ")").html();
                },
                position: {my: "left+5 center", at: "right center"},
                tooltipClass: "deliveryTooltip"
            }).on("mouseover focusin", function (e) {
                if ($(window).width < 1024) {
                    e.preventDefault();
                    return false;
                }
            });
        });

        $(".delivery-radio-btn.disabled .has-icon, .delivery-radio-btn.disabled .has-icon img").each(function (i, el) {
            $(el).on('mouseover focusin', function (e) {
                e.stopPropagation();
            });
        });
    },

    summaryScroll: function () {
        $(window).on("load resize", function () {
            $(".checkout-order-summary-list-items:visible").addClass("summary-cont");
            var maxHeight = 0;
            var maxHeightAmds = 0;
            // amds table
            $(".checkout-order-summary-list-items.summary-cont.amds-products tbody tr:lt(3)").each(function () {
                maxHeightAmds += $(this).outerHeight();
            });
            $(".checkout-order-summary-list-items.summary-cont.amds-products tbody").css("max-height", maxHeightAmds + "px")
            if ($(".checkout-order-summary-list-items.summary-cont.amds-products tbody tr").length > 3) {
                $(".checkout-order-summary-list-items.summary-cont.amds-products tbody").mCustomScrollbar({
                    theme: "dark-3"
                });
            }

            //mkp table
            var vendorHeight = 0;
            $(".checkout-order-summary-list-items.summary-cont.mkp-products tbody tr.item:lt(3)").each(function () {
                maxHeight += $(this).outerHeight();
            });
            $(".checkout-order-summary-list-items.summary-cont.mkp-products tbody tr.vendor__name").each(function () {
                vendorHeight += $(this).outerHeight();
            });
            sumHeight= maxHeight + vendorHeight;

            $(".checkout-order-summary-list-items.mkp-products tbody").css("max-height", sumHeight + "px")
            if ($(".checkout-order-summary-list-items.summary-cont.mkp-products tbody >tr.item").length> 3) {
                $(".checkout-order-summary-list-items.summary-cont.mkp-products tbody").css("max-height", maxHeight + "px")
                $(".checkout-order-summary-list-items.summary-cont.mkp-products tbody").mCustomScrollbar({
                    theme: "dark-3"
                });
            }
        });


        $(window).on('scroll', () => {
            if (!$('body').hasClass('page-multiStepCheckoutSummaryPage')) return;

            const $checkoutSummary = $('.js-checkout-summary');
            const $orderSummary = $('.checkout-order-summary.hidden-xs:visible');
            const $checkoutLeftSide = $('.checkout-left-side');
            const $checkoutRightSide = $('.checkout-right-side');
            const $footer = $('footer');
            const $faq = $('.myaccount-bloc-questions__faq');

            // Calculate summary height (use last element if multiple exist)
            const summaryHeight = $checkoutSummary.length ? $checkoutSummary.last().height() : 0;

            // Get positions
            const windowScrollTop = $(window).scrollTop();
            const footerTopPosition = $footer.offset().top - windowScrollTop;
            const orderSummaryHeight = $orderSummary.height();
            const orderSummaryTopPosition = $orderSummary.offset().top - windowScrollTop + orderSummaryHeight;
            const faqPosition = $faq.length ? $faq.offset().top - orderSummaryHeight : 0;
            const scrollThreshold = windowScrollTop + summaryHeight + 140;

            // Handle sticky class for order summary
            if (windowScrollTop >= 50 && scrollThreshold <= faqPosition) {
                $orderSummary.addClass('sticky').removeClass('sticky-bottom');
            } else {
                $orderSummary.removeClass('sticky');
            }

            // Handle sticky-bottom behavior
            if (!ACC.checkout) ACC.checkout = { orderSummaryTopPosition: 0 };

            if (footerTopPosition <= (orderSummaryTopPosition + 10) && !ACC.checkout.orderSummaryTopPosition) {
                ACC.checkout.orderSummaryTopPosition = order26.html
                orderSummaryTopPosition = $orderSummary.position().top + orderSummaryHeight;

                $checkoutRightSide.height($checkoutLeftSide.height());
                $orderSummary.addClass('sticky-bottom');
            } else if (footerTopPosition >= (ACC.checkout.orderSummaryTopPosition + 10)) {
                ACC.checkout.orderSummaryTopPosition = 0;
                $checkoutRightSide.removeAttr('style');
                $orderSummary.removeClass('sticky-bottom');
            }
        });
    },

    deleteFormsCookie: function (form) {
        var name = $(form).attr('id');
        $.cookie(name, null);

    },
    clickOrderConfirmationBanner: function () {
        $(document).on('click', '.orderConfirmation__banner a', function () {
            var bannerName = $('.orderConfirmation__banner').data('banner-name');
            window.open(this.href);
            ACC.track.orderConfirmationBannerClickEvent(bannerName);
            return false;
        });
    },
    viewOrderConfirmationBanner: function () {

        if ($(".checkout__confirmation__content--component .orderConfirmation__banner").length > 0) {
            var bannerName = $('.orderConfirmation__banner').data('banner-name');
            ACC.track.orderConfirmationBannerViewEvent(bannerName);
        }
    },
    quoteTransformationAdaptation: function () {
        $('.quote-transformation-adaptation-alert').on('click', '.close-parent',function (){
            $('.quote-transformation-adaptation').remove();
            $('.checkout-headline, .backToCartLink').removeClass('hide');
            $('.checkout-right-side').removeClass('with-quote-transformation');
        })

    }
};
